import React, { useState } from 'react';

// import CustomScroll from 'react-custom-scroll';
import { Scrollbars } from 'react-custom-scrollbars';

import Checkbox from '@material-ui/core/Checkbox';
/* Material UI */
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

import css from './nibCardList.module.sass';

const Item = ({ lable, firstVal = false, secondVal = false, ...props }) => {
  let [first, setFirst] = useState(firstVal);
  let [second, setSecond] = useState(secondVal);
  return (
    <ListItem>
      <div className={css.inner}>
        <Typography className={css.label}>{lable}</Typography>
        <div className={css.checkBox}>
          <Checkbox checked={first} onChange={(e) => setFirst(e.target.checked)} color="primary" />
        </div>
        <div className={css.checkBox}>
          <Checkbox checked={second} onChange={(e) => setSecond(e.target.checked)} color="primary" />
        </div>
      </div>
    </ListItem>
  );
};

const NibCardList = ({ items = [], columns = [], width, height, ...props }) => {
  return (
    <List className={css.list} dense style={{ width: '100%' }}>
      <div className={css.labels}>
        {columns.map((col) => (
          <Typography key={col}>{col}</Typography>
        ))}
      </div>
      <Scrollbars style={{ width: '100%', height: 150 }}>
        {items.map((item) => (
          <Item key={item.label} lable={item.label} firstVal={item.first} secondVal={item.second} />
        ))}
      </Scrollbars>
    </List>
  );
};

export default NibCardList;
